<template>
  <div class="warp">
    <div class="z-flex handle-stage handle-stage-num">
      <div class="_label">阶段：</div>
      <div class="_input">{{ visitInfo.stageName }}</div>
    </div>
    <div class="z-flex handle-stage">
      <div class="_label">时间：</div>
      <div class="_input">
        <a-date-picker
          :value="moment(visitInfo.followDate)"
          format="YYYY-MM-DD"
          style="width: 200px"
          disabled
        />
      </div>
    </div>
    <div class="z-flex handle-stage">
      <div class="_label">结果：</div>
      <a-radio-group
        :options="flowResultStatusList"
        v-model:value="followResult"
        @change="handleChange"
      />
    </div>
  </div>
</template>
<script setup>
import { flowResultStatusList } from './config'
import { defineProps, defineEmits, ref, onMounted } from 'vue'
import moment from 'moment'
defineProps({
  visitInfo: {
    type: Object,
    default: () => {}
  }
})
const emits = defineEmits(['followResultChange'])
const followResult = ref(null)
function handleChange(e) {
  const val = e.target.value
  emits('followResultChange', val)
}
onMounted(() => {
  followResult.value = null
})
</script>
<style scoped lang="scss">
.handle-stage {
  justify-content: flex-start;
  align-items: center;
  font-weight: 400;
  font-size: 14px;
  color: #333333;
  margin-bottom: 16px;
  &.handle-stage-num {
    margin-bottom: 22px;
  }
  ._label {
    color: #666666;
    padding-right: 8px;
    text-align: left;
  }
  ._input {
    position: relative;
  }
}
</style>
